import {NilUUID} from '../../../lib/utils/NilUUID'

class Author {

    constructor(uuid, name, nodeId) {
        this.uuid = uuid
        this.name = name
        this.nodeId = nodeId
        this.isLoaded = false
        this.isSimpleAuthor = NilUUID.isNilUUID(this.uuid) ? true : false
    }

    static _isEqual(author, other) {
        if (author === null || author === undefined) {
            return false
        }
        if (other === null || other === undefined) {
            return false
        }
        if (author.isSimpleAuthor) {
            return other.name === author.name
        } else {
            return other.uuid === author.uuid
        }
    }
}

export default Author
